import { createBrowserRouter, RouterProvider, Navigate } from "react-router";
import AppShell from "@/components/layout/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import CampaignEditor from "@/pages/CampaignEditor";
import CampaignDetail from "@/pages/CampaignDetail";
import Contacts from "@/pages/Contacts";
import ContactDetail from "@/pages/ContactDetail";
import Templates from "@/pages/Templates";
import SmsTemplates from "@/pages/SmsTemplates";
import LineTemplates from "@/pages/LineTemplates";
import CallCampaigns from "@/pages/CallCampaigns";
import CallCampaignEditor from "@/pages/CallCampaignEditor";
import CallCampaignDetail from "@/pages/CallCampaignDetail";
import Sequences from "@/pages/Sequences";
import SequenceEditor from "@/pages/SequenceEditor";
import SequenceDetail from "@/pages/SequenceDetail";
import MetaAudiences from "@/pages/MetaAudiences";
import MetaAudienceEditor from "@/pages/MetaAudienceEditor";
import MetaSettings from "@/pages/MetaSettings";
import FaxReceived from "@/pages/FaxReceived";
import CallTranscripts from "@/pages/CallTranscripts";
import DoNotCallList from "@/pages/DoNotCallList";
import Prospects from "@/pages/Prospects";
import AiManager from "@/pages/AiManager";
import AudienceLists from "@/pages/AudienceLists";
import AudienceListDetail from "@/pages/AudienceListDetail";

const router = createBrowserRouter([
  { path: "/login", element: <Login /> },
  {
    path: "/",
    element: <AppShell />,
    children: [
      { index: true, element: <Dashboard /> },
      { path: "campaigns/new", element: <CampaignEditor /> },
      { path: "campaigns/:id", element: <CampaignDetail /> },
      { path: "campaigns/:id/edit", element: <CampaignEditor /> },
      { path: "call-campaigns", element: <CallCampaigns /> },
      { path: "call-campaigns/new", element: <CallCampaignEditor /> },
      { path: "call-campaigns/:id", element: <CallCampaignDetail /> },
      { path: "call-campaigns/:id/edit", element: <CallCampaignEditor /> },
      { path: "call-transcripts", element: <CallTranscripts /> },
      { path: "sequences", element: <Sequences /> },
      { path: "sequences/new", element: <SequenceEditor /> },
      { path: "sequences/:id", element: <SequenceDetail /> },
      { path: "sequences/:id/edit", element: <SequenceEditor /> },
      { path: "fax-received", element: <FaxReceived /> },
      { path: "do-not-call", element: <DoNotCallList /> },
      { path: "contacts", element: <Contacts /> },
      { path: "audience-lists", element: <AudienceLists /> },
      { path: "audience-lists/:id", element: <AudienceListDetail /> },
      { path: "prospects", element: <Prospects /> },
      { path: "contacts/:id", element: <ContactDetail /> },
      { path: "templates", element: <Templates /> },
      { path: "sms-templates", element: <SmsTemplates /> },
      { path: "line-templates", element: <LineTemplates /> },
      { path: "meta-audiences", element: <MetaAudiences /> },
      { path: "meta-audiences/new", element: <MetaAudienceEditor /> },
      { path: "meta-audiences/:id", element: <MetaAudienceEditor /> },
      { path: "meta-audiences/:id/edit", element: <MetaAudienceEditor /> },
      { path: "meta-settings", element: <MetaSettings /> },
      { path: "ai-manager", element: <AiManager /> },
    ],
  },
  { path: "*", element: <Navigate to="/" replace /> },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
